import { ClmClaimer } from "./ClmClaimer";
import { ClmClaim } from "./ClmClaim";
import { ClmDeclaration } from "./ClmDeclaration";
import { GzzRepresenter } from "../general/GzzRepresenter";
import { FormGroup } from "@angular/forms";



export class ClmClaimDetails {
  ClaimerDetails: ClmClaimer;
  RepresenterDetails: GzzRepresenter;
  ClaimDetails: ClmClaim;
  DeclarationDetails: ClmDeclaration;

  constructor(data: ClmClaimDetails) {
    Object.assign(this, data);

    this.ClaimerDetails = new ClmClaimer(data.ClaimerDetails);
    this.RepresenterDetails = new GzzRepresenter(data.RepresenterDetails);
    this.ClaimDetails = new ClmClaim(data.ClaimDetails);
    this.DeclarationDetails = new ClmDeclaration(data.DeclarationDetails);
    //delete this['Declaration'];
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/claim/ClmClaimDetails.ts